<section class="masthead-page masthead-blog montserrat">
    <p class="card-text montserrat text-center">IN EVIDENZA</p>
</section>

<section class="textblock wrapper marginauto montserrat">
    <div class="row">

        <div class="col-11 pt-5 pb-4">

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/"><i class="fa fa-home" aria-hidden="true"></i> Home</a></li>
                    <li class="breadcrumb-item active" aria-current="page">In evidenza</li>
                </ol>
            </nav>
    
        </div>

    </div>
</section>

<section class="textblock wrapper marginauto montserrat blog">
    <div class="row marginauto">

        <div *ngFor="let article of articles" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pb-4">
            <div class="card">

                <a class="text title" href="{{ article.url }}">
                    <img class="lazyload card-img-top" [src]="article.src" [alt]="article.alt" [title]="article.title">
                </a><br>

                <div class="card-body text-small">
                    <div class="card-text-height">
                        <a class="text title" href="{{ article.url }}">{{ article.title }}</a>

                        <div class="card-body text-small">
                            <span [innerHTML]="article.desc"></span>
                        </div>

                        <div class="row mt-2">
                            <div class="col">
                                <span class="mb-5 badge badge-pill badge-secondary">{{ article.section }}</span>
                            </div>
                        </div>

                    </div>

                    <div class="clearfix my-3"></div>

                    <div class="float-xl-right float-lg-right float-md-none float-sm-none float-right"> 
                        <a href="{{ article.url }}" class="btn btn-primary">Leggi l'articolo</a>
                    </div>

                    <div class="clearfix"></div>
                </div>
            </div>
        </div>

    </div>

    <div class="col-11 pt-5 pb-4">

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/"><i class="fa fa-home" aria-hidden="true"></i> Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">In evidenza</li>
            </ol>
        </nav>

    </div>

</section>

<section class="py-3"></section>